
$(document).ready(function() {

	"use strict";

	PageLoad();


});



/*--------------------------------------------------
Function Page Load
---------------------------------------------------*/

	function PageLoad() {

		if ($('#page-content').hasClass("light-content")) {
			$('.preloader-wrap').addClass('light-content');
		}

		TweenMax.set($(".menu-timeline .before-span"), {y: 120, opacity:0});


		$('body').removeClass('hidden').removeClass('hidden-ball');
		TweenMax.to($(".preloader-marquee-wrapper"), 1, {force3D:true, opacity:1, y: 0, delay:0.2, ease:Power3.easeOut});
		TweenMax.to($("#header-container"), 0.5, {force3D:true, opacity:1, delay:0.2, ease:Power2.easeOut}); //modified time
		var width = 100,
			perfData = window.performance.timing,
			EstimatedTime = -(perfData.loadEventEnd - perfData.navigationStart),
			time = ((400/10)%50) * 80




		// Percentage Increment Animation
		var PercentageID = $("#precent"),
				start = 0,
				end = 100,
				durataion = time + 0;
				animateValue(PercentageID, start, end, durataion);

		function animateValue(id, start, end, duration) {

			var range = end - start,
			  current = start,
			  increment = end > start? 1 : -1,
			  stepTime = Math.abs(Math.floor(duration / range)),
			  obj = $(id);

			var timer = setInterval(function() {
				current += increment;
				$(obj).text(current);
			  //obj.innerHTML = current;
				if (current == end) {
					clearInterval(timer);
				}
			}, stepTime);
		}

		// Fading Out Loadbar on Finised
		setTimeout(function(){
			$('.loadbar').append('<span class="hold-progress-bar"></span>');

			TweenMax.to($('.hold-progress-bar'), 0.3, {force3D:true,width:'100%', delay:0, ease:Power2.easeOut, onComplete:function(){  //modified time 2019 nov

				$('body').waitForImages({
						finished: function() {
							TweenMax.to('#ball', 0.2,{borderWidth: '4px', scale:0.5, borderColor:'#999999', backgroundColor:'transparent'});
							TweenMax.to('#ball-loader', 0.2,{borderWidth: '4px', top: 0, left: 0});
							$('#ball p').remove();
							TweenMax.to($(" .trackbar, .percentage"),0.3, {force3D:true, opacity:0, y:-10, delay:0, ease:Power2.easeIn});
							TweenMax.to($(" .preloader-marquee"),0.5, {force3D:true, opacity:0, y:-40, delay:0.1, ease:Power2.easeIn});
							TweenMax.to($(".preloader-wrap"),1, {force3D:true, opacity:0, delay:0.6, ease:Power2.easeInOut});
							TweenMax.set($(".preloader-wrap"), {visibility:'hidden', delay:1.7, opacity:0});
							TweenMax.to($("#header-container"), 0.5, {force3D:true, opacity:1, delay:1.4, ease:Power2.easeOut}); //modified time
							setTimeout(function(){

								$('body').waitForImages({
									finished: function() {
										TweenMax.to($(".header-middle, #footer-container, .showcase-counter, .swiper-pagination-bullet-active .counter"), 1, {force3D:true, opacity:1, delay:0, ease:Power2.easeOut});

									},
									waitForAll: true
								});

								if( $('.hero-video-wrapper').length > 0 ){
									$('#hero-image-wrapper').find('video').each(function() {
										$(this).get(0).play();
									});
								}

								TweenMax.to($("#main"), 0, {force3D:true, opacity:1, delay:0, ease:Power2.easeOut});//modified time
								if( $('#hero').hasClass("has-image")) {
									TweenMax.to($("#hero-bg-image, #hero-fg-image"), 1, {force3D:true, scale:1 , opacity:1, delay:0.2, ease:Power2.easeOut});
									TweenMax.to($(".hero-title div"), 1, {force3D:true, y: 0, opacity:1, delay:0.5, ease:Power2.easeOut});
									TweenMax.to($(".hero-subtitle span"), 0.7, {force3D:true, y:0, opacity:1, rotation:0, delay:0.9, ease:Power2.easeOut});
									TweenMax.to($(".hero-footer-left"), 0.7, {force3D:true, y: 0, opacity:1, rotation:0, delay:1, ease:Power2.easeOut});
									TweenMax.to($(".hero-footer-right"), 0.7, {force3D:true, y:0, opacity:1, rotation:0, delay:1, ease:Power2.easeOut});
									TweenMax.to($(".scroll-down-wrap"), 1, {force3D:true, scale:1, opacity:1, delay:1.2, ease: Elastic.easeOut});
									TweenMax.to($("#main-page-content"), 0.4, {force3D:true, opacity:1, y:0, delay:1.15, ease:Power2.easeOut});
								} else {
									// Fading In Small Carousel elements on Finised
									TweenMax.to($(".hero-title div"), 1, {force3D:true, y: 0, opacity:1, delay:0.5, ease:Power2.easeOut});
									TweenMax.to($(".hero-subtitle span"), 0.7, {force3D:true, y:0, opacity:1, rotation:0, delay:0.9, ease:Power2.easeOut});
									TweenMax.to($(".hero-footer-left"), 0.7, {force3D:true, y: 0, opacity:1, rotation:0, delay:1, ease:Power2.easeOut});
									TweenMax.to($(".hero-footer-right"), 0.7, {force3D:true, y:0, opacity:1, rotation:0, delay:1, ease:Power2.easeOut});
									TweenMax.to($("#main-page-content"), 0.7, {force3D:true, opacity:1, y:0, delay:1.3, ease:Power2.easeOut});
								}


								// Fading In Showcase elements on Finised
								TweenMax.set($("#canvas-slider"), {scale:1.1});
								TweenMax.set($(".showcase-footer .quickmenu, .showcase-footer .socials-wrap, .swiper-pagination-bullet .parallax-element"), {opacity:0});
								TweenMax.to($("#canvas-slider"), 1, {force3D:true, opacity:1, scale:1, delay:0.3, ease:Power2.easeOut});
								TweenMax.to($(".swiper-pagination-bullet .title div"), 1, {force3D:true, y: 0, opacity:1, delay:0.5, ease:Power2.easeOut});
								TweenMax.to($(".swiper-pagination-bullet-active .subtitle span"), 0.7, {force3D:true, y: 0, opacity:1, delay:0.9, ease:Power2.easeOut});
								TweenMax.to($(".showcase-footer .quickmenu"), 0.7, {force3D:true, y: 0, opacity:1, rotation:0, delay:1.2, ease:Power2.easeOut});
								TweenMax.to($(".swiper-pagination-bullet .parallax-element"), 0.7, {force3D:true, y:0, opacity:1, rotation:0, delay:1, ease:Power2.easeOut});
								TweenMax.to($(".showcase-footer .socials-wrap"), 0.7, {force3D:true, y: 0, opacity:1, rotation:0, delay:1.2, ease:Power2.easeOut});
								setTimeout( function(){
									$('#showcase-slider-webgl-holder').addClass("loaded");
								} , 1000 );




								setTimeout( function(){
									$('body').removeClass("load-project-page").removeClass("load-project-page-carousel");
								} , 600 );

								setTimeout( function(){
									$('body').removeClass("load-next-project");
									$('body').addClass("header-visible");
									$('#showcase-holder').removeClass("disabled");
								} , 1600 );

								setTimeout( function(){
									$('body').removeClass("show-loader")
								} , 800 );

							} , 600 );
						},
					waitForAll: true
				});

			}});

		}, time);



	}// End Page Load

 









